<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-hover v-slot="{ hover }">

          <v-card :style="{border: 'white'}"
                  :class="hover?'elevation-1 rounded-lg pa-5 glass-effect-hover':'elevation-1 rounded-lg pa-5 glass-effect'">
            <v-row>
              <v-card-title>
                <span class="white--text ml-2">{{ title }}</span>
                <v-chip x-small
                        v-if="receipt.created_by || receipt.created_at"
                        style="font-size: 10px" color="back" class="white--text">
                  ساخته شده توسط
                  <span v-if="receipt.created_by" class="mr-1 ml-1 info--text font-weight-bold">

                  {{ receipt.created_by.name || receipt.created_by }}

                  </span>
                  در
                  <span class="mr-1  font-weight-bold" v-if="receipt.created_at">  {{ receipt.created_at }} </span>

                </v-chip>
                <v-spacer></v-spacer>
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        left
                        id="form-clear-btn"
                        @click.prevent="newForm()"
                        href="#/"
                        class="secondary mr-3 "
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                      <v-img max-height="20" max-width="20" src="/img/icons/new_form.svg"></v-img>
                    </v-btn>
                  </template>
                  ثبت ورود جدید
                </v-tooltip>
              </v-card-title>

            </v-row>
            <v-row>
              <v-col col="12" md="12">
                <v-text-field label="نام"
                              v-model="receipt.name" background-color="white" class="rounded-lg"
                              :disabled="!is_editing"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="6">
                <v-text-field label="نام راننده"
                              v-model="receipt.driver_name" background-color="white" class="rounded-lg"
                              :disabled="!is_editing"/>

              </v-col>
              <v-col col="12" md="6">
                <money label="تعداد کل جعبه ها" :disabled="id" class="rounded-lg"
                       v-model="receipt.box_count"></money>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="6">
                <date
                    v-model="receipt.enter_date"
                    label="تاریخ"
                    :default="false"
                    :disabled="id"/>
              </v-col>
              <v-col col="12" md="6">
                <mtime
                    v-model="receipt.enter_time"
                    label="ساعت"
                    :default="false"
                    :disabled="id"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col col="12" md="12">
                <v-textarea
                    class="rounded-lg"
                    v-model="receipt.explanation"
                    label="توضیحات"
                    rows="2"
                    :disabled="!is_editing"/>
              </v-col>
            </v-row>

            <v-row>
              <v-col col="12" md="12">
                <store-select
                    class="rounded-lg"
                    label="انبار"
                    v-model="receipt.store"
                    :disabled="id || package_selected"
                >
                </store-select>
              </v-col>
            </v-row>
            <v-row v-if="receipt.store">
              <v-col col="12" md="12">
                <supplier-select
                    class="rounded-lg"
                    label="تامین کننده"
                    v-model="receipt.supplier"
                    @input="getPackage(receipt.supplier)"
                ></supplier-select>
              </v-col>
            </v-row>
            <v-row v-if="receipt.supplier && items.length > 0">
              <v-col col="12" md="12">
                <v-table>
                  <thead>
                  <tr class="white--text">
                    <th class="text-center" style="font-size: x-small">
                      کد محصول
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      نام محصول
                    </th>
                    <th class="text-center" style="font-size: x-small" v-if="!id">
                      تعداد کارتون
                    </th>
                    <th class="text-center" style="font-size: x-small" v-if="!id">
                      تعداد محصول درکارتون
                    </th>
                    <th class="text-center" style="font-size: x-small" v-if="!id">
                      تعداد محصول باقی مانده
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      تعداد کارتون تحویل شده
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      تعداد محصول در هر کارتون تحویل شده
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      تعداد خرابی
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      تعداد تولید محتوا
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      بارکد
                    </th>
                    <th class="text-center" style="font-size: x-small">
                      کد قفسه
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in items">
                    <td class="text-center">
                      <v-text-field :disabled="true" class="rounded-lg" v-model="item.product_code"></v-text-field>
                    </td>
                    <td class="text-center">
                      <v-text-field :disabled="true" class="rounded-lg" v-model="item.default_name"></v-text-field>
                    </td>
                    <td class="text-center">
                      <money :disabled="true"  class="rounded-lg" v-model="item.number_of_box"></money>
                    </td>
                    <td class="text-center">
                      <money :disabled="true" class="rounded-lg" v-model="item.number_of_products_per_box"></money>
                    </td>
                    <td class="text-center" v-if="!id">
                      <money :disabled="true" class="rounded-lg" v-model="item.number_of_products"></money>
                    </td>
                    <td class="text-center" v-if="!id">
                      <money :disabled="id" class="rounded-lg" v-model="item.input_box"></money>
                    </td>
                    <td class="text-center" v-if="!id">
                      <money :disabled="id" class="rounded-lg" v-model="item.input_product_per_box"></money>
                    </td>
                    <td class="text-center">
                      <money type="number" :disabled="id" class="rounded-lg" v-model="item.failure_count"></money>
                    </td>
                    <td class="text-center">
                      <money type="number" :disabled="id" class="rounded-lg" v-model="item.content_production_count"></money>
                    </td>
                    <td class="text-center">
                      <v-text-field :disabled="id" class="rounded-lg" v-model="item.barcode"></v-text-field>
                    </td>
                    <td class="text-center">
                      <v-text-field :disabled="id" class="rounded-lg" v-model="item.new_product_shelf_code"></v-text-field>
                    </td>

                  </tr>
                  </tbody>
                </v-table>

              </v-col>
            </v-row>
            <row v-else-if="receipt.supplier">
              <v-col class="text-center white--text mt-2" cols="12">
                <v-icon color="white">fa-check</v-icon>
                <strong>              پکیج این تامین کننده کامل تحویل شده
                </strong>
              </v-col>
            </row>

            <v-card-actions>
              <v-row no-gutters class="d-flex flex-column-reverse flex-md-row mt-5">
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-start mt-2 mt-md-0">
                </v-col>
                <v-col cols="12" md="6" class="d-flex justify-center justify-md-end">
                  <v-btn
                      v-if="is_editing"
                      :disabled="!receipt.supplier"
                      @click="submitReceipt()"
                      depressed
                      color="success"
                      class="w-100px  green white--text rounded-lg">
                    ثبت
                  </v-btn>
                  <v-btn
                      v-else
                      @click="is_editing=true"
                      depressed
                      color="warning"
                      class="w-100px white--text rounded-lg"
                  >ویرایش</v-btn>


                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-hover>

      </v-col>


      <v-col cols="12" md="6">
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters"
                     ref="datatable" :show-select="false"
                     @dblclick:row="(e, row) => $router.push(to(row.item))"
        >
        </m-datatable>


      </v-col>
    </v-row>
  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";
import Time from "@/components/mcomponents/cleave/Time";
import StoreSelect from "@/components/selects/StoreSelect";
import SupplierSelect from "@/components/selects/SupplierSelect";


export default {
  name: "StoreReceipt",
  components: {SupplierSelect, StoreSelect, Time},
  mixins: [MFormMixin, formsMixin, FormsMixin],
  props: {
    id: {},
  },
  data() {
    return {
      url: "entrance/lists/storeReceipt",
      filters: {},
      is_editing: true,
      stores: [],
      packages: [],
      items: [],
      receipt: {},
      package_selected: false,
    };
  },
  computed: {
    title() {
      return 'ورود به انبار'
    },
    headers() {
      return [
        {
          text: "نام",
          value: "name",
        },
      ];
    },
  },
  updated() {
  },
  created() {
    if (this.id) {
      this.getReceipt()
      this.is_editing = false

    }
  },
  mounted() {
    if (this.$route.query.package) {
      this.package_selected = true
      this.receipt.store = this.$route.query.store
      this.getStoresPackage(this.receipt.store)
      this.receipt.entrance_packages = this.$route.query.package
      this.getPackage(this.receipt.entrance_packages)
    }

  },
  watch: {
    id() {
      if (this.id) {
        this.getReceipt()
      }
    },
    'receipt.store'() {
      this.getStoresPackage(this.receipt.store)
    }
  },

  methods: {
    to(item) {
      return {
        name: "StoreReceipt",
        params: {
          id: item.id,
        },
      };
    },
    newForm() {
      this.is_editing = true
      this.package_selected = false
      this.receipt = {}
      this.changeRouteTo(null)
      this.$router.push(
          {
            name: "StoreReceipt",
          }
      )
    },
    getStoresPackage(id) {
      this.request({
        url: this.endpoint(`entrance/storeEntrancePackages/${id}/`),
        method: "get",
        success: data => {
          this.packages = []
          for (let pack of data) {
            this.packages.push({
              'name': 'پکیج  ' + pack.name + ' در ' + this.toJDate(pack.registration_date),
              'value': pack.id,
            })
          }
        }
      })
    },
    getPackage(id) {
      if (!this.receipt.id) {
        this.request({
          url: this.endpoint(`entrance/supplierPackageRemain/${id}`),
          method: "get",
          success: data => {
            this.items = data
          }
        })
      }
    },
    getReceipt() {
      this.request({
        url: this.endpoint(`entrance/receipt/${this.id}`),
        method: "get",
        success: data => {
          this.receipt = data
          this.items = data.items
          this.getStoresPackage(data.store)
        }
      })
    },
    createReceiptItems(id) {
      this.request({
        url: this.endpoint(`entrance/createReceiptsItems`),
        method: "post",
        data: {
          store_receipt: id,
          items: this.items,
        },
        success: (data) => {
          console.log(data)
        },
      });

    },

    submitReceipt() {
      if (!this.receipt.id){
        this.request({
          url: this.endpoint(`entrance/submitStoreReceipt`),
          method: "post",
          data: this.receipt,
          success: data => {
            this.receipt = data
            this.changeRouteTo(data.id)
            this.$refs.datatable.getDataFromApi()
            this.createReceiptItems(data.id)
            this.is_editing = false
          }
        })
      } else {
        this.request({
          url: this.endpoint(`entrance/receipt/${this.receipt.id}`),
          method: "put",
          data: this.receipt,
          success: data => {
            this.receipt = data
            this.changeRouteTo(data.id)
            this.$refs.datatable.getDataFromApi()
            this.is_editing = false
          }
        })

      }

    },


  },
}
</script>

<style scoped lang="scss">
.glass-effect {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(
          5px
  );
}

.glass-effect-hover {
  transition: backdrop-filter 0.5s ease;
  background-color: rgba(230, 230, 230, 0.2);
  backdrop-filter: blur(20px);
}
.cursor-pointer {
  cursor: pointer !important;
}

</style>

